import React from "react";
import { BsCodeSlash } from "react-icons/bs";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <BsCodeSlash className="icon-size" style={{ color: "#6f42c1" }} />
        <span style={{ fontWeight: 700, fontSize: "1.2rem", color: "#6f42c1" }}>DataCode</span>
      </div>
      <div className="navbar-right">
        <Link to="/" className="nav-item">Landing Page</Link>
        <Link to="/thirtydaylanding" className="nav-item">30 Days Landing</Link>
      </div>
    </nav>
  );
}

export default Navbar;
